export class UnsupportedContractTypeError extends Error {
  constructor(public readonly contractType: string) {
    super(`Unsupported contract type ${contractType}.`);
    Object.setPrototypeOf(this, UnsupportedContractTypeError.prototype);
  }
}
